export default "__VITE_ASSET__CQ8OT534__"